import React, { useEffect, useState } from "react";
import { Button, Container } from "react-bootstrap";
import Table from "react-bootstrap/Table";
import Form from "react-bootstrap/Form";
import {
  GetAllDoctors,
  GetAllDoctorsSpecial,
  CheckDocSpecialAvailable,
  CreateDocSpecial,
  UpdateDocSpecial,
  DeleteDocSpecial,
} from "../../utils/proxy/Doctorproxy";
import ReactPaginate from "react-paginate";
import Modal from "react-bootstrap/Modal";
import Swal from "sweetalert2";
import DataTable from "react-data-table-component";
import { AiFillDelete, AiTwotoneEdit } from "react-icons/ai";
import { Parser } from "@json2csv/plainjs";
import { HiDotsVertical } from "react-icons/hi";
import { IoHomeOutline } from "react-icons/io5";
import { FaPlus } from "react-icons/fa6";
import { Op_per } from "../../utils/Permissions";

function Doctorspecial() {
  const [doctorspecialization, setDoctorSpecialization] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [show, setShow] = useState(false);
  const [docspecialization, setDocSpecialization] = useState("");
  const [isdocspecialization, setIsDocSpecialization] = useState();
  const [docdesc, setDocDesc] = useState("");
  const [reload, SetReload] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const [pending, setPending] = React.useState(true);

  const [currentId, setCurrentId] = useState();
  const [editShow, setEditShow] = useState(false);

  const filteredData = doctorspecialization.filter((row) =>
    row.specialization.toLowerCase().includes(searchQuery.toLowerCase())
  );

  useEffect(() => {
    // Fetch data from an API when the component mounts
    const getalldocspecialization = async () => {
      let doctorspecializationdata = await GetAllDoctorsSpecial();
      if (doctorspecializationdata) {
        setDoctorSpecialization(doctorspecializationdata);
        setPending(false);
      } else {
        alert("Error", "Issue While Fetching Doctors Specializations");
      }
    };
    getalldocspecialization();
    SetReload(false);
  }, [reload]);

  useEffect(() => {
    const getallcountries = async (docspecialization) => {
      if (docspecialization.length > 0) {
        let statedata = await CheckDocSpecialAvailable(docspecialization);
        if (statedata) {
          setIsDocSpecialization(true);
        } else {
          setIsDocSpecialization(false);
        }
      }
    };
    getallcountries(docspecialization);
  }, [docspecialization]);

  // Function to handle page change
  const handlePageChange = (selectedPage) => {
    setCurrentPage(selectedPage.selected);
  };

  // Pagination configuration
  const itemsPerPage = 10; // Number of items per page
  const pageCount = Math.ceil(filteredData.length / itemsPerPage); // Total number of pages

  // Calculate the current page's items
  const startIndex = currentPage * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentPageItems = filteredData.slice(startIndex, endIndex);

  const handleClose = () => {setShow(false);setIsDocSpecialization(false)}
  const handleShow = () => setShow(true);

  const handleEditShow = (row) => {
    setDocSpecialization(row.specialization);
    setDocDesc(row.description);
    setCurrentId(row.id);
    setEditShow(true);
  };

  const handleEditClose = () => {setEditShow(false);setIsDocSpecialization(false)}

  const handleSpecializationChange = (event) => {
    setDocSpecialization(event.target.value);
  };

  const handleDescriptionChange = (event) => {
    setDocDesc(event.target.value);
  };

  let createDocSpecialization = async (docspecialization, docdesc) => {
    let statedata = await CreateDocSpecial(docspecialization, docdesc);
    if (statedata) {
      SetReload(true);
      setShow(false);

      Swal.fire({
        title: "Success!",
        text: "Specialization Added Successfully !!",
        icon: "success",
        confirmButtonText: "OK",
      });
    } else {
      alert("Error", "Issue While Fetching Data");
    }
  };

  let handleSave = (event) => {
    if (isdocspecialization == false && docdesc.length > 0) {
      createDocSpecialization(docspecialization, docdesc);
    }
  };

  let updatedspecialization = async (currentId, docspecialization, docdesc) => {
    let statedata = await UpdateDocSpecial(
      currentId,
      docspecialization,
      docdesc
    );
    if (statedata) {
      SetReload(true);
      setEditShow(false);

      Swal.fire({
        title: "Success!",
        text: "Specialization Updated Successfully !!",
        icon: "success",
        confirmButtonText: "OK",
      });
      setCurrentId(null);
      setDocSpecialization('');
      setDocDesc('');
      setIsDocSpecialization(false);
    } else {
      alert("Error", "Issue While Fetching Data");
    }
  };

  let handleedit = (event) => {
    updatedspecialization(currentId, docspecialization, docdesc);
    // updateDegree(currentId,docdegree,docdesc)
  };

  let deletspecialization = async (id) => {
    let statedata = await DeleteDocSpecial(id);
    if (statedata) {
      SetReload(true);

      Swal.fire({
        title: "Success!",
        text: "Specialization Deleted Successfully !!",
        icon: "success",
        confirmButtonText: "OK",
      });
    } else {
      alert("Error", "Issue While Fetching Data");
    }
  };

  let handledelete = (id) => {
    deletspecialization(id);
  };

  const columns = [
    // {
    //   name: "Id",
    //   selector: (row) => row.id,
    //   sortable: true,
    //   width:"5%",
    // },
    {
      name: "Specialization",
      selector: (row) =>
      <div style={{ whiteSpace: 'normal',backgroundColor:  row.specialization === "" ||  row.specialization === null ? "#f36e6f":"", borderRadius:"10px", border:  row.specialization === "" ||  row.specialization === null ? "2px solid transparent": "2px solid transparent",padding:"3px", display:"flex", flexDirection:"row",color: row.specialization === "" ||  row.specialization === null ? "#fff": "#000", margin:"3px", }}>{ row.specialization ?  row.specialization : "N/A"}</div> ,
      sortable: true,
      width:"10%",
      
      
    },
    {
      name: "Description",
      selector: (row) => <div style={{ whiteSpace: 'normal',backgroundColor: row.description === "" || row.description === null ? "#f36e6f":"", borderRadius:"10px", border: row.description === "" || row.description === null ? "2px solid transparent": "2px solid transparent",padding:"3px", display:"flex", flexDirection:"row",color:row.description === "" || row.description === null ? "#fff": "#000", margin:"3px", }}>{row.description ? row.description : "N/A"}</div> ,
      sortable: true,
      width:"30%",
    },
    // {
    //   name: "Actions",
    //   selector: (row) => (
    //     <div key={row.id}>
    //       <AiFillDelete
    //         onClick={() => handledelete(row.id)}
    //         style={{ color: "#f36e6f", fontSize: 20 }}
    //       />
    //       &nbsp;&nbsp;&nbsp;
    //       <AiTwotoneEdit
    //         onClick={() => handleEditShow(row)}
    //         style={{ color: "#9889e6", fontSize: 20 }}
    //       />
    //     </div>
    //   ),
    // },
  ];

  if(Op_per.get().OPTIONS_SPECIALITY_MASTER.ALLOW_DELETE || Op_per.get().OPTIONS_SPECIALITY_MASTER.ALLOW_EDIT){
    columns.push({
      name: "Actions",
      selector: (row) => (
        <div key={row.id}>
          <AiFillDelete
            onClick={() => handledelete(row.id)}
            style={{ color: "#f36e6f", fontSize: 20, display:Op_per.get().OPTIONS_SPECIALITY_MASTER.ALLOW_EDIT ? '' : 'none' }}
          />
          &nbsp;&nbsp;&nbsp;
          <AiTwotoneEdit
            onClick={() => handleEditShow(row)}
            style={{ color: "#9889e6", fontSize: 20, display:Op_per.get().OPTIONS_SPECIALITY_MASTER.ALLOW_EDIT ? '' : 'none' }}
          />
        </div>
      ),
    })
  }

  const customStyles = {   head: {     style: {       backgroundColor: 'blue',     },   }, };
  const CustomHeader = ({ children }) => (   <div style={{ backgroundColor: 'blue', padding: '10px', color: 'white' }}>    {children}  </div>);

  async function downloadCSV(doctorspecialization) {
    let csv;
    try {
      const opts = {
        fields: ["id", "degree", "description"],
      };
      const parser = new Parser(opts);
      csv = parser.parse(doctorspecialization);
    } catch (err) {
      console.error(err);
    }

    const link = document.createElement("a");

    if (csv == null) return;

    const filename = "export.csv";

    if (!csv.match(/^data:text\/csv/i)) {
      csv = `data:text/csv;charset=utf-8,${csv}`;
    }

    link.setAttribute("href", encodeURI(csv));
    link.setAttribute("download", filename);
    link.click();
  }

  const Export = ({ onExport }) => (
    <Button onClick={(e) => onExport(e.target.value)}>Export All</Button>
  );

  const actionsMemo = React.useMemo(
    () => <Export onExport={() => downloadCSV(doctorspecialization)} />,
    [doctorspecialization]
  );

  return (
    <Container fluid style={{ minHeight: "80vh" }}>
      <div
        className="glass-body"
        style={{
          margin: 10,
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          padding:0,
          backgroundColor:'transparent'
        }}
      >

<div style={{display:"flex", justifyContent:"center", alignItems:"center"}}>
<ul id="breadcrumb">
  <li><a href="/"><IoHomeOutline
            style={{ color: "white", fontSize: 20 }}
            
          /></a></li>
  <li><a href="/doctor-specialization"><span class="icon icon-beaker"> </span>Options</a></li>
  <li><a href="/doctor-specialization"><span class="icon icon-beaker"> </span>Dr. Speciality Master</a></li>
  {/* <li><a href="#"><span class="icon icon-double-angle-right"></span>Doctor</a></li> */}
  
</ul>
	
</div>
      
      </div>

      <div className="glass-body" style={{ margin: 10 }}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
          className="flex-column-mobile"
        >
          <div>
            <Form.Control
             style={{height: 40,
            width:250,
            borderColor: '#ccc',
            borderWidth: 1,
            paddingHorizontal: 8,
            marginBottom: 16,
            borderRadius:10
          }}
              className="glass"
              placeholder="Search Specialization"
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
          <div>
            <Button style={{backgroundColor: "#2194f0", display:Op_per.get().OPTIONS_SPECIALITY_MASTER.ALLOW_ADD ? '' : 'none' }} onClick={handleShow}>
            <FaPlus />
            </Button>
          </div>
        </div>
        <div style={{ marginTop: 10 }}>
          <DataTable
            columns={columns}
            data={filteredData}
            progressPending={pending}
            pagination
            customStyles={{headRow: {style: {backgroundColor: '#c0dfff',  padding:10,borderRadius:'10px 10px 0 0' }, }  }}
                        CustomHeader={<CustomHeader/>}
            // actions={actionsMemo}
            style={{ marginTop: 10 }}
            dense
          />
        </div>
      </div>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Add Doctor Specialization</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Specialization <span style={{color:"red"}}>*</span></Form.Label>

              <Form.Control
                style={{
                  backgroundColor: isdocspecialization ? "#f36e6f" : "",
                  color: isdocspecialization ? "#fff" : "",
                  height: 40,
           
            borderColor: '#ccc',
            borderWidth: 1,
            paddingHorizontal: 8,
            marginBottom: 16,
            borderTopLeftRadius:20,
            borderBottomRightRadius:20,
                }}
                type="text"
                onChange={handleSpecializationChange}
                placeholder="Enter Specialization"
                required
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formBasicPassword">
              <Form.Label>Description <span style={{color:"red"}}>*</span></Form.Label>
              <Form.Control
               style={{height: 40,
           
            borderColor: '#ccc',
            borderWidth: 1,
            paddingHorizontal: 8,
            marginBottom: 16,
            borderTopLeftRadius:20,
            borderBottomRightRadius:20,}}
                type="text"
                onChange={handleDescriptionChange}
                placeholder="Enter Description"
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button
            variant="primary"
            onClick={handleSave}
            disabled={isdocspecialization ? true : false}
          >
            Save
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={editShow} onHide={handleEditClose}>
        <Modal.Header closeButton>
          <Modal.Title>Add Doctor Specialization</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Specialization <span style={{color:"red"}}>*</span></Form.Label>

              <Form.Control
              style={{height: 40,
           
           borderColor: '#ccc',
           borderWidth: 1,
           paddingHorizontal: 8,
           marginBottom: 16,
           borderRadius:10,}}
                type="text"
                onChange={handleSpecializationChange}
                placeholder="Enter Specialization"
                value={docspecialization}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formBasicPassword">
              <Form.Label>Description <span style={{color:"red"}}>*</span></Form.Label>
              <Form.Control
              style={{height: 40,
           
           borderColor: '#ccc',
           borderWidth: 1,
           paddingHorizontal: 8,
           marginBottom: 16,
           borderRadius:10,}}
                type="text"
                onChange={handleDescriptionChange}
                value={docdesc}
                placeholder="Enter Description"
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleEditClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleedit}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
}

export default Doctorspecial;
